module.exports = __webpack_public_path__ + "img/dropsmith-bogo-detail.af6f9854.png";